import { Component, OnInit } from '@angular/core';

import {Filters, Product, Wheels} from '../../shared/interfaces/wheels';
import {ApiServices} from '../../shared/services/api.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {DataService} from '../../shared/services/data.service';
import {HelperService} from '../../shared/services/helper.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
	queryParams: Params;
  loadProducts = false;
  searchVehicleSub: Subscription;
  loadMoreProducts = false;
  hasNextPage = false;
  filters: Filters;
  products = [];
  brand: any;
  showFilters = false;
  // currentRoute = '/wheelbrand';
  currentRoute = '/wheels';

  keywords: any;
  searchResult : any = [];
  types:any = [];


  constructor(private apiService: ApiServices, private dataService: DataService, private router: Router, private route: ActivatedRoute, private helperService: HelperService) { 
    helperService.setPageTitle(route.snapshot.data.title);
    this.subscribes();
  }

  subscribes(): void {
    this.route.queryParams.subscribe(params => {
      this.keywords = params.keywords;
      if(this.keywords==undefined || this.keywords == ''){
        // redirect to product page
        this.router.navigate(['/wheels', '']);
      } else {
        this.search();
      }
    });

  }


  ngOnInit(): void {
    $('body .opac-layer').click();
    this.search();
    
    // this.getFilters();
    // this.currentRoute = window.location.pathname == '/alloy-wheels' ? '/alloy-wheels' : '/wheelbrand';
    // this.search();
  }

  getFilters = () => {
    this.apiService.getFilters(this.queryParams).subscribe(response => {
        this.filters = response.data.filters;
      }
    );
  }

  search(): void {
    if(this.keywords!=undefined || this.keywords != ''){
      this.apiService.search(this.keywords).subscribe(response => {
        let _types = response.types;
        var count = 0;
        for(let t = 0; t < _types.length; t++){
          if(_types[t] == 'products' || _types[t] == 'brands'){
            this.types[count] = _types[t];
            count++;
          }
        }

        for(let i= 0; i < this.types.length; i++){
          let _tt = this.types[i];
          this.searchResult[_tt] = response.result[_tt];
        }
      });
    } else {
      this.searchResult = [];
      this.types = [];
    }
  }

  getAll = () => {
    this.loadProducts = true;
    this.searchVehicleSub = this.apiService.getAllProducts(this.queryParams).subscribe(
      (response: Wheels) => {
        this.products = [...this.products, ...response.data.products.data];
        this.loadMoreProducts = false;
        this.loadProducts = false;
        //  this.filters = response.data.filters;
        if (response.data.products.next_page_url) {
          this.hasNextPage = true;
        } else {
          this.hasNextPage = false;
        }
      }, err => {
        this.loadMoreProducts = false;
      }
    );
  }

  onFilterSelections = (params) => {
    this.products = [];
    if (this.currentRoute == '/wheelbrand') {
      this.router.navigate(['/wheels?brand='+this.brand], {queryParams: params});
      // this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
      // this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
    } else {
      this.router.navigate([this.currentRoute], {queryParams: params});
    }
  }

  onClear = (isClear) => {
    this.products = [];
    if (isClear) {
      this.getAll();
    }
  }

  changePerPage = ($event) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    params.perPage = $event.target.value;
    if (this.currentRoute == '/wheelbrand') {
      this.router.navigate(['/wheels?brand='+this.brand], {queryParams: params});
      // this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
    } else {
      this.router.navigate([this.currentRoute], {queryParams: params});
    }
  }

  sortBy = (event) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    params.sortBy = event.target.value;
    if (this.currentRoute == '/wheelbrand') {
      this.router.navigate(['/wheels?brand='+this.brand], {queryParams: params});
      // this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
    } else {
      this.router.navigate([this.currentRoute], {queryParams: params});
    }
  }

  loadMore = () => {
    this.loadMoreProducts = true;
    setTimeout( () => {
      const params = Object.assign({}, this.queryParams);
      params.page = params.page ? ++params.page : 2;
      if (this.currentRoute == '/wheelbrand') {
        this.router.navigate(['/wheels?brand='+this.brand], {queryParams: params});
        // this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
      } else {
        this.router.navigate([this.currentRoute], {queryParams: params});
      }
    }, 500);
  }

  onhideFilters(): void {
    this.showFilters = false;
  }

}
